module.exports = __webpack_public_path__ + "img/58.ba46ca0f.b7da86f7.svg";